module.exports = __webpack_public_path__ + "static/media/firstdraft.367b0415.svg";